module.exports = __webpack_public_path__ + "static/media/realtors-icon-16.cc5517fa.svg";